module.exports = __webpack_public_path__ + "static/media/svg-1.6df11fc2.svg";